export default __webpack_public_path__ + "static/media/left_arrow.b461b744.svg";